var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"justify-center",attrs:{"app":"","id":"footer","inset":"","color":"#efeff7"}},[_vm._v(" Copyright 2018-"+_vm._s(new Date().getFullYear())+" Surefire Local | All Rights Reserved ")])}
var staticRenderFns = []

export { render, staticRenderFns }